import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import mrTranslations from '../utils/translations/mr.json';
import enTranslations from '../utils/translations/en.json';

const translations = {
  mr: mrTranslations,
  en: enTranslations,
};

export const useTranslation = () => {
  const { language, toggleLanguage } = useContext(LanguageContext);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    // Fallback to English if translation not found
    if (!value && language !== 'en') {
      let fallback = translations.en;
      for (const k of keys) {
        fallback = fallback?.[k];
      }
      return fallback || key;
    }
    
    return value || key;
  };

  return { t, language, toggleLanguage };
};
